import { render, staticRenderFns } from "./AuthorModalFigcaption.vue?vue&type=template&id=2694c612&"
import script from "./AuthorModalFigcaption.vue?vue&type=script&lang=ts&"
export * from "./AuthorModalFigcaption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports